import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from '../services/auth';

interface ProtectedRouteProps {
  children: JSX.Element;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();
  const authenticated = isAuthenticated();
  
  // console.log('ProtectedRoute check:', { 
  //   path: location.pathname, 
  //   authenticated,
  //   token: localStorage.getItem('token'),
  //   expirationTime: localStorage.getItem('expirationTime')
  // });

  if (!authenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}
